"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.default = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _applyDecoratedDescriptor2 = _interopRequireDefault(require("@babel/runtime/helpers/applyDecoratedDescriptor"));
var _mobx = require("mobx");
var _dateFns = require("date-fns");
var _get2 = _interopRequireDefault(require("lodash/get"));
var _without2 = _interopRequireDefault(require("lodash/without"));
var _store = require("@tajawal/web-core-sdk-v2/lib/utils/store.utils");
var _order = require("@tajawal/ct-web-payment-sdk/lib/stores/api/order.store");
var _downloadOrderPdf = require("@tajawal/web-payment-sdk-v2/lib/stores/download-order-pdf.store");
var _staticResources = _interopRequireDefault(require("@tajawal/web-payment-sdk-v2/lib/stores/static-resources.store"));
var _hotelInfo = _interopRequireDefault(require("@tajawal/web-hotel-sdk-v2/lib/stores/hotel-info.store"));
var _constants = require("@tajawal/web-core-sdk-v2/lib/constants");
var _constants2 = require("../constants");
var _bookings = require("../utils/bookings.utils");
var _class;
const {
  PAYFORT,
  TAJAWAL_PAY,
  FORT,
  PAY_LATER,
  QITAF,
  WALLET,
  INSTALLMENTS,
  APPLE_PAY
} = _constants2.PAYMENT_METHODS;

/**
 * ManageHotelBookingStore
 */
let ManageHotelBookingStore = (_class = /*#__PURE__*/function () {
  /**
   * constructor
   * @param {Object} initialState
   * @param {Object} $env
   */
  function ManageHotelBookingStore(initialState = {}, $env) {
    (0, _classCallCheck2.default)(this, ManageHotelBookingStore);
    this.$env = $env;
    this.updateInitialState(initialState);
    this.order = new _order.OrderStore(initialState.order, $env);
    this.hotelInfo = new _hotelInfo.default(initialState.hotelInfo, $env);
    this.orderPdf = new _downloadOrderPdf.DownloadOrderPdfStore(initialState.orderPdf, $env);
    this.staticResourcesStore = new _staticResources.default();
  }

  /**
   * is cover disabled
   * @return {boolean}
   */
  (0, _createClass2.default)(ManageHotelBookingStore, [{
    key: "isCoverDisabled",
    get: function () {
      return [_constants2.HOTEL_ORDER_END_USER_STATUS.NOT_CONFIRMED, _constants2.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_LATER, _constants2.HOTEL_ORDER_END_USER_STATUS.CANCELLED_PAY_NOW].includes(this.order.hotel.endUserStatus);
    }

    /**
     * show manage booking
     * @return {boolean}
     */
  }, {
    key: "showManageBooking",
    get: function () {
      return [_constants2.HOTEL_ORDER_END_USER_STATUS.CONFIRMED, _constants2.HOTEL_ORDER_END_USER_STATUS.PAYMENT_PENDING].includes(this.order.hotel.endUserStatus);
    }

    /**
     * hotel search url
     * @return {string}
     */
  }, {
    key: "hotelSearchUrl",
    get: function () {
      return `${this.$env.config.language}/hotels/${this.order.hotel.name}?hotelId=${this.order.hotel.id}`;
    }

    /**
     * mweb hotel search url
     * @return {string}
     */
  }, {
    key: "mWebHotelSearchUrl",
    get: function () {
      return `mweb/hotels/${this.order.hotel.name}?hotelId=${this.order.hotel.id}`;
    }

    /**
     * is fully refundable
     * @return {boolean}
     */
  }, {
    key: "isFullyRefundable",
    get: function () {
      return (0, _dateFns.isBefore)(new Date(), this.order.hotel.firstCancellationDate);
    }

    /**
     * paylaterOptions
     * @description returns the available payment options for paylater
     * @returns {paylaterOptions[]}
     */
  }, {
    key: "paylaterOptions",
    get: function () {
      const options = (0, _get2.default)(this.order, 'data.allowedPaymentMethods', []).filter(method => ![QITAF, TAJAWAL_PAY, PAYFORT, FORT, WALLET].includes(method.provider)).map(method => method.provider);
      if (this.canPayWithInstallments) {
        options.push(INSTALLMENTS);
      }
      if (options.includes(PAY_LATER) && !this.canPayWithBank) return (0, _without2.default)(options, PAY_LATER);
      if (this.canPayWithApplePay) {
        options.push(APPLE_PAY);
      }
      return options;
    }

    /**
     * checks whether bank payment option is available
     * @returns {Boolean}
     */
  }, {
    key: "canPayWithBank",
    get: function () {
      return this.$env.config.isAlmosafer && [_constants.DOMAINS.AM_DEV_COM, _constants.DOMAINS.AM_LIVE_COM, _constants.DOMAINS.AM_DEV_BH, _constants.DOMAINS.AM_LIVE_BH].includes(this.$env.config.domain);
    }

    /**
     * checks whether installments payment option is available
     * @returns {Boolean}
     */
  }, {
    key: "canPayWithInstallments",
    get: function () {
      return this.$env.config.isInstallmentsEnabled && this.order.total >= 1000;
    }

    /**
     * checks whether apple pay payment option is available
     * @returns {Boolean}
     */
  }, {
    key: "canPayWithApplePay",
    get: function () {
      return this.$env.config.isApplePayEnabled && !!this.order.appleMIdHeader && this.staticResourcesStore.canPayWithApplePay;
    }

    /**
     * charged amount
     * @return {String}
     */
  }, {
    key: "chargedAmount",
    get: function () {
      return (0, _get2.default)(this.order.hotel.cancellation, 'cancellationPolicies.0.convertedFinalRate');
    }

    /**
     * update initial state
     * @param {Object} initialState
     */
  }, {
    key: "updateInitialState",
    value: function updateInitialState(initialState) {
      (0, _store.mapInitialStateToStoreState)(this, initialState);
    }
  }, {
    key: "bookingTagStatus",
    get: function () {
      return (0, _bookings.getBookingTagStatus)(this.order.data.displayStatus);
    }
  }]);
  return ManageHotelBookingStore;
}(), ((0, _applyDecoratedDescriptor2.default)(_class.prototype, "isCoverDisabled", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isCoverDisabled"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "showManageBooking", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "showManageBooking"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "hotelSearchUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "hotelSearchUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "mWebHotelSearchUrl", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "mWebHotelSearchUrl"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "isFullyRefundable", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "isFullyRefundable"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "paylaterOptions", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "paylaterOptions"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "canPayWithBank", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canPayWithBank"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "canPayWithInstallments", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canPayWithInstallments"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "canPayWithApplePay", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "canPayWithApplePay"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "chargedAmount", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "chargedAmount"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "updateInitialState", [_mobx.action], Object.getOwnPropertyDescriptor(_class.prototype, "updateInitialState"), _class.prototype), (0, _applyDecoratedDescriptor2.default)(_class.prototype, "bookingTagStatus", [_mobx.computed], Object.getOwnPropertyDescriptor(_class.prototype, "bookingTagStatus"), _class.prototype)), _class);
exports.default = ManageHotelBookingStore;